import { IResourceComponentsProps, useExport } from '@pankod/refine-core'

import {
  List,
  RefreshButton,
  CreateButton,
  ExportButton,
  Table,
  Space,
  EditButton,
  DeleteButton,
  DateField,
  getDefaultSortOrder,
  useModalForm,
  Icons,
  Input,
  Divider,
  Button,
  useTable,
  Form
} from '@pankod/refine-antd'
// import { useTable } from '@pankod/refine-core'
import { IExplanationTypes } from 'interfaces'
import { CreateExplanationType } from './create'
import { EditExplanationType } from './edit'
import { useState } from 'react'
import { exportToExcel } from 'exportToExcel'
const { PlusOutlined } = Icons

export const ExplanationTypeList: React.FC<IResourceComponentsProps> = () => {
  const [pagination,setHasPagination]=useState<any>(true)
  const { tableProps,searchFormProps, sorter, tableQueryResult,setFilters } = useTable<IExplanationTypes>({
    hasPagination:pagination,
    initialSorter: [
      {
        field: 'created_at',
        order: 'desc',
      },
    ],
    metaData: {
      fields: ['id', 'name', 'description', 'created_at', { questions: ['id'] }],
    },
    onSearch: (values:any) => {
      return [
          {
              field: "name",
              operator: "contains",
              value:`%${values.title}%`,
          },
      ];
  },
  })
  const {  tableQueryResult:exportData } = useTable<IExplanationTypes>({
    hasPagination:false,
    initialSorter: [
      {
        field: 'created_at',
        order: 'desc',
      },
    ],
    metaData: {
      fields: ['id', 'name', 'description', 'created_at', { questions: ['id'] }],
    },
  })
  const { formProps, modalProps, show } = useModalForm({
    resource: 'explanation_types',
    action: 'create',
  })
  const {
    formProps: editFormProps,
    modalProps: editModalProps,
    show: editShow,
  } = useModalForm({
    resource: 'explanation_types',
    action: 'edit',
    metaData: {
      fields: ['id', 'name', 'description', 'created_at'],
    },
  })
// Edit Modal

  const hideDeleteButton = (record: IExplanationTypes): boolean => {
    if (record?.questions !== undefined) {
      return record.questions.length > 0
    }
    return false
  }
  const triggerExport=()=>{
    exportToExcel(tableQueryResult?.data?.data,`ExplanationTypes_${Math.round(new Date().getTime() / 1000)}.xlsx`)
  }

  // const { triggerExport, isLoading } = useExport<IExplanationTypes>()
 
  return (
    <List
      pageHeaderProps={{
        extra: [
          //  <ExportButton onClick={triggerExport} loading={isLoading} />,
          <RefreshButton onClick={() => tableQueryResult?.refetch()} />,
          <CreateButton type="primary" icon={<PlusOutlined />} onClick={() => show()} />,
          <Button onClick={triggerExport}>Export</Button>
        ],
      }}
    >
              <Form {...searchFormProps}>
        <Space>
            <Form.Item name="title">
                <Input placeholder="Search by title" allowClear  onChange={(e)=>{
                            if(e.type==='click'){
                              searchFormProps.form?.submit()
                            }}}/>
            </Form.Item>
            <Button icon={<Icons.SearchOutlined/>} onClick={searchFormProps.form?.submit} >Search</Button>
        </Space>
    </Form>
    <Divider/>
      <Table {...tableProps} >
        <Table.Column dataIndex="name" title="Name" />
        {/* <Table.Column dataIndex="description" title="Description" /> */}
        <Table.Column
          dataIndex="created_at"
          title="Created At"
          render={value => <DateField value={value} format="LLL" />}
          defaultSortOrder={getDefaultSortOrder('created_at', sorter)}
          sorter
        />
        <Table.Column<IExplanationTypes>
          title="Actions"
          dataIndex="actions"
          render={(_, record) => (
            <Space>
              <EditButton size="small" type="link" icon={null} recordItemId={record.id} onClick={() => editShow(record.id)} />
              <DeleteButton size="small" type="link" icon={null} recordItemId={record.id} hidden={hideDeleteButton(record)} />
            </Space>
          )}
        />
      </Table>
      <CreateExplanationType modalProps={modalProps} formProps={formProps} />
      <EditExplanationType modalProps={editModalProps} formProps={editFormProps} />
    </List>
  )
}
